export type WarningModalInput = {
  header: string;
  body: string;
  body_extra?: string;
  body_icon?: string;
  confirmButtonText: string;
  rejectButtonText: string;
  extraText?: string;
  extraClass?: string;
};

export enum BUTTON_CLICK {
  ACCEPT = 'accept',
  REJECT = 'reject',
}
